const INITIAL_STATE = {
    list: [],
    paginaAtual: 0 
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'USUARIO_FETCHED':
            return { ...state, list: action.payload.data }
        case 'USUARIO_PAGE':
            return { ...state, paginaAtual: action.payload };
        default:
            return state
    }
}